import { classNames } from "primereact";
import { observer } from "mobx-react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { isHardwareDevice } from "../../api/firebase/types/device.types";
import { screenSize, useMediaQuery } from "../../hooks/responsiveLayout";
import DeviceStore from "../../store/DeviceStore";
import IncidentStore from "../../store/IncidentStore";
import DeviceBatteryTemplate from "./DeviceBatteryTemplate";
import IncidentOverviewCard from "./IncidentOverviewCard";

const HomeView: React.FC = () => {
  const devices = DeviceStore.devices;
  const incidents = IncidentStore.incidents;
  const realIncidents = incidents.filter(
    (incident) => incident.deviceTestMode !== true
  );

  const [width] = useMediaQuery();

  return (
    <div
      className={classNames("homeview-container", "p-grid", {
        "p-jc-center": width < screenSize.tablet,
        "p-px-3": width >= screenSize.tablet,
      })}
    >
      <h2>Willkommen in der Verwaltung des Digitalen Notfallmeldesystems</h2>
      <h3 className="p-col-12">Vergangene Alarme</h3>
      <IncidentOverviewCard incidents={realIncidents} />
      <h3 className="p-col-12 p-mt-5">Meldeinstanzen</h3>
      <div className="p-col-6">
        <Toolbar left={() => <h3 className="p-ml-2">Iot-Buttons</h3>} />
        <DataTable
          value={devices.filter(isHardwareDevice)}
          title="IoT-Buttons"
          className="p-datatable-striped"
          size="small"
          scrollable
          scrollHeight="400px"
          responsiveLayout="scroll"
        >
          <Column field="name" header="Bezeichnung" />
          <Column
            header="Akkustand"
            body={(device) => (
              <DeviceBatteryTemplate deviceId={device.deviceId} />
            )}
          />
          <Column
            field="deviceTestMode"
            header="Testmodus"
            body={(device) => <div>{device.deviceTestMode ? "An" : "Aus"}</div>}
          />
        </DataTable>
      </div>
      <div className="p-col-6">
        <Toolbar left={() => <h3 className="p-ml-2">Desktop Clients</h3>} />
        <DataTable
          value={devices.filter((device) => !isHardwareDevice(device))}
          title="IoT-Buttons"
          className="p-datatable-striped"
          size="small"
          scrollable
          scrollHeight="400px"
          responsiveLayout="scroll"
        >
          <Column field="name" header="Bezeichnung" />
          <Column field="email" header="Email" />
          <Column
            field="deviceTestMode"
            header="Testmodus"
            body={(device) => <div>{device.deviceTestMode ? "An" : "Aus"}</div>}
          />
        </DataTable>
      </div>
    </div>
  );
};
export default observer(HomeView);
